import { defineMessages, type MessageValue, type NoMessageValues } from 'react-intl';

// ─── Messages ────────────────────────────────────────────────────────────────

export const navbarV2Messages = defineMessages<{
  readonly account: NoMessageValues;
  readonly bag: NoMessageValues;
  readonly bagAccessibilityLabel: { readonly count: number | bigint };
  readonly buyGiftCards: NoMessageValues;
  readonly close: NoMessageValues;
  readonly closeNavigation: NoMessageValues;
  readonly closeNavigationBackdrop: NoMessageValues;
  readonly createYourOwn: NoMessageValues;
  readonly findLocationNearYou: NoMessageValues;
  readonly goBack: NoMessageValues;
  readonly groupOrderInviteeTitle: { readonly host_name: MessageValue };
  readonly groupOrderLocationEyebrow: { readonly orderChannel: string };
  readonly giftCardsDescription: NoMessageValues;
  readonly giftCardsImageAlt: NoMessageValues;
  readonly home: NoMessageValues;
  readonly homeAccessibilityLabel: NoMessageValues;
  readonly logInOrSignUp: NoMessageValues;
  readonly locationEyebrow: { readonly orderChannel: string };
  readonly menu: NoMessageValues;
  readonly more: NoMessageValues;
  readonly moreMenu: NoMessageValues;
  readonly myAccount: NoMessageValues;
  readonly navigationMenu: NoMessageValues;
  readonly openNavigation: NoMessageValues;
  readonly rewards: NoMessageValues;
  readonly signInCreateAccount: NoMessageValues;
  readonly start: NoMessageValues;
  readonly startMenu: NoMessageValues;
  readonly startOrder: NoMessageValues;
  readonly viewMenu: NoMessageValues;
  readonly viewOrderHistory: NoMessageValues;
}>({
  account: {
    defaultMessage: 'Account',
    description: 'Navbar V2 | Account link label',
  },
  bag: {
    defaultMessage: 'Bag',
    description: 'Navbar V2 | Bag button label',
  },
  bagAccessibilityLabel: {
    defaultMessage: '{count, plural, =0 {Bag} one {Bag, # item} other {Bag, # items}}',
    description: 'Navbar V2 | Bag button accessibility label',
  },
  buyGiftCards: {
    defaultMessage: 'Buy Gift Cards',
    description: 'Navbar V2 | More menu | Fallback gift cards link label',
  },
  close: {
    defaultMessage: 'Close',
    description: 'Navbar V2 | Start menu | Close button label',
  },
  closeNavigation: {
    defaultMessage: 'Close navigation',
    description: 'Navbar V2 | Close navigation button accessibility label',
  },
  closeNavigationBackdrop: {
    defaultMessage: 'Close navigation backdrop',
    description: 'Navbar V2 | Navigation backdrop accessibility label',
  },
  createYourOwn: {
    defaultMessage: 'Create your own',
    description: 'Navbar V2 | Start menu | Create your own link label',
  },
  findLocationNearYou: {
    defaultMessage: 'Find location near you',
    description: 'Navbar V2 | Find location button label',
  },
  goBack: {
    defaultMessage: 'Go back',
    description: 'Navbar V2 | Back link accessibility label',
  },
  groupOrderInviteeTitle: {
    defaultMessage: "{host_name}'s Group Order",
    description: 'Navbar V2 | Invitee group order title',
  },
  groupOrderLocationEyebrow: {
    defaultMessage:
      'Group Order - {orderChannel, select, delivery {Deliver to:} pickup {Pickup from:} outpost {Outpost at:} other {}}',
    description: 'Navbar V2 | Host group order location eyebrow',
  },
  giftCardsDescription: {
    defaultMessage: 'Give the gift of green',
    description: 'Navbar V2 | More menu | Fallback gift cards link description',
  },
  giftCardsImageAlt: {
    defaultMessage: 'Sweetgreen gift cards',
    description: 'Navbar V2 | More menu | Fallback gift cards image accessibility label',
  },
  home: {
    defaultMessage: 'Home',
    description: 'Navbar V2 | Home link label',
  },
  homeAccessibilityLabel: {
    defaultMessage: 'Sweetgreen home',
    description: 'Navbar V2 | Home link accessibility label',
  },
  logInOrSignUp: {
    defaultMessage: 'Log in / Sign up',
    description: 'Navbar V2 | Authentication button label',
  },
  locationEyebrow: {
    defaultMessage:
      '{orderChannel, select, delivery {Deliver to} pickup {Pickup from} outpost {Outpost at} other {Deliver to}}',
    description: 'Navbar V2 | Location button eyebrow',
  },
  menu: {
    defaultMessage: 'Menu',
    description: 'Navbar V2 | Menu link label',
  },
  more: {
    defaultMessage: 'More',
    description: 'Navbar V2 | More link label',
  },
  moreMenu: {
    defaultMessage: 'More menu',
    description: 'Navbar V2 | More menu accessibility label',
  },
  myAccount: {
    defaultMessage: 'My account',
    description: 'Navbar V2 | More menu | Account link label',
  },
  navigationMenu: {
    defaultMessage: 'Navigation menu',
    description: 'Navbar V2 | Drawer accessibility label',
  },
  openNavigation: {
    defaultMessage: 'Open navigation',
    description: 'Navbar V2 | Open navigation button accessibility label',
  },
  rewards: {
    defaultMessage: 'Rewards',
    description: 'Navbar V2 | Rewards link label',
  },
  signInCreateAccount: {
    defaultMessage: 'Sign in / Create account',
    description: 'Navbar V2 | Drawer | Authentication link label',
  },
  start: {
    defaultMessage: 'Start',
    description: 'Navbar V2 | Start menu | Open button label',
  },
  startMenu: {
    defaultMessage: 'Start an order',
    description: 'Navbar V2 | Start menu | Options list accessibility label',
  },
  startOrder: {
    defaultMessage: 'Order',
    description: 'Navbar V2 | Start order button label',
  },
  viewMenu: {
    defaultMessage: 'View menu',
    description: 'Navbar V2 | Start menu | View menu link label',
  },
  viewOrderHistory: {
    defaultMessage: 'View order history',
    description: 'Navbar V2 | More menu | Order history link label',
  },
});
